module.exports = __webpack_public_path__ + "img/icon_map_5_c.a5864107.png";